export default __webpack_public_path__ + "static/media/step2-v2.84ee9517.png";